import { dynamicSortMultipleFields } from 'utils/sorting';
import { otherUserTypes } from 'ducks/user/types';
import {
  articlesTypes,
  otherUserArticlesTypes,
  createArticleTypes,
  updateArticleTypes,
  autoSaveArticleTypes,
} from './types';

const articlesInitialState = {
  all: {
    list: [],
    isLoading: false,
  },
  published: {
    list: [],
    isLoading: false,
  },
  draft: {
    list: [],
    isLoading: false,
  },
  submitted: {
    list: [],
    isLoading: false,
  },
  rejected: {
    list: [],
    isLoading: false,
  },
};
const initialState = {
  articles: articlesInitialState,
};

const userArticleReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case otherUserTypes.SUCCESS: {
      return {
        ...state,
        otherUser: {
          articles: {},
        },
      };
    }

    case articlesTypes.REQUEST: {
      const { articleType } = payload;
      return {
        ...state,
        articles: {
          ...state.articles,
          [articleType]: { ...state.articles[articleType], isLoading: true },
        },
      };
    }

    case articlesTypes.SUCCESS: {
      const { articleType, articles, count, currentPage } = payload;
      return {
        ...state,
        articles: {
          ...state.articles,
          [articleType]: {
            ...state.articles[articleType],
            count,
            currentPage,
            list: articles.sort(dynamicSortMultipleFields('-lastEdited')),
            isLoading: false,
          },
        },
      };
    }

    case articlesTypes.FAILED: {
      const { articleType } = payload;
      return {
        ...state,
        articles: {
          ...state.articles,
          [articleType]: { ...state.articles[articleType], isLoading: false },
        },
      };
    }

    case articlesTypes.SUCCESS_BY_ID: {
      return { ...state, currentArticle: payload };
    }

    case articlesTypes.FAILED_BY_ID: {
      return { ...state, currentArticleError: payload };
    }

    case articlesTypes.RESET_CURRENT: {
      return { ...state, currentArticle: undefined };
    }

    case otherUserArticlesTypes.REQUEST: {
      return {
        ...state,
        otherUser: {
          articles: {
            isLoading: true,
          },
        },
      };
    }

    case otherUserArticlesTypes.SUCCESS: {
      const { articles, count, currentPage } = payload;
      return {
        ...state,
        otherUser: {
          articles: {
            count,
            currentPage,
            isLoading: false,
            list: articles,
          },
        },
      };
    }

    case otherUserArticlesTypes.FAILED: {
      return {
        ...state,
        otherUser: {
          articles: {
            error: payload,
            isLoading: false,
          },
        },
      };
    }

    case createArticleTypes.REQUEST:
    case updateArticleTypes.REQUEST: {
      return { ...state, creatingArticle: true };
    }

    case createArticleTypes.SUCCESS:
    case updateArticleTypes.SUCCESS: {
      return {
        ...state,
        articles: articlesInitialState,
        creatingArticle: false,
        currentDraft: payload,
      };
    }

    case createArticleTypes.FAILED:
    case updateArticleTypes.FAILED: {
      return { ...state, creatingArticle: false, error: payload };
    }

    case articlesTypes.SET_CURRENT_DRAFT: {
      return { ...state, currentDraft: payload };
    }

    case autoSaveArticleTypes.SUCCESS: {
      return { ...state, articles: articlesInitialState, currentDraft: payload };
    }

    default:
      return state;
  }
};

export default userArticleReducer;
